import React from 'react'
import SendWeddingWish from 'components/SendWeddingWish';

export default function SendWeddingWishPage() {
    return <div style={{
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#F8F6EC",
        border: "1px solid #ffe24f",
        width: 500,
        borderRadius: 20,
        padding: 20, 
    }}>
        <SendWeddingWish />
    </div>
}
